import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-link-icon',
  imports: [MatIconModule],
  template: `
    <button class="link-btn" mat-icon-button (click)="onClick($event)">
      <mat-icon [style.color]="row?.isLinked ? '#5F6368' : '#2D8CFF'">
        {{ row?.isLinked ? 'link_off' : 'link' }}
      </mat-icon>
    </button>
  `
})
export class LinkIconComponent {
  @Input() row: any;
  @Output() linkClick = new EventEmitter<any>();

  onClick(event: Event) {
    event.stopPropagation(); // table row click avoid
    this.linkClick.emit(this.row);
  }
}